import React from "react";
import {
  Create,
  SimpleForm,
  LongTextInput,
  TextInput,
  translate,
  ReferenceInput,
  email,
  required
} from "admin-on-rest";
import RichTextInput from "aor-rich-text-input";
import AutocompleteInput from "../../../components/CRM/AutocompleteInput";
import AutoComplete from "material-ui/AutoComplete";
import {formStyle} from "./style";
import {connect} from "react-redux";
import {validateStoreMessageData, validateStoreName} from "./validations";

class StoreMessageCreateForm extends React.Component {
  render() {
    const props = {...this.props};
    const reduxErrors = {...props.errors};
    const errors = {...reduxErrors.syncErrors};

    return (
      <Create {...props}>
        <SimpleForm
          redirect="show"
          validate={validateStoreMessageData}
          label=""
        >
          <ReferenceInput
            label="resources.virtualSlips.inputs.storeName"
            source="kiosk_id"
            reference="kiosks"
            validate={validateStoreName}
            sort={{field: "name", order: "ASC"}}
            perPage={50}
            allowEmpty={false}
            style={formStyle.containerInput}
          >
            <AutocompleteInput
              options={{filter: AutoComplete.caseInsensitiveFilter}}
            />
          </ReferenceInput>
          <TextInput
            label="resources.storeMessages.inputs.smsFrom"
            source="sms_from"
            validate={required}
          />
          <LongTextInput
            label="resources.storeMessages.inputs.smsText"
            source="sms_text"
            validate={required}
          />
          <TextInput
            label="resources.storeMessages.inputs.emailFrom"
            source="email_from"
            type="email"
            validate={[email, required]}
          />
          <LongTextInput
            label="resources.storeMessages.inputs.emailSubject"
            source="email_subject"
            validate={required}
          />
          <LongTextInput
            label="resources.storeMessages.inputs.contentPlainText"
            source="email_plaintext"
            validate={required}
          />
          <RichTextInput
            label="resources.storeMessages.inputs.contentHtml"
            source="email_html"
            validate={required}
          />
          {(reduxErrors.anyTouched || reduxErrors.submitFailed) &&
            errors.email_html && (
              <span style={formStyle.validationStyle}>
                {props.translate(
                  "resources.storeMessages.validation.emailHtml"
                )}
              </span>
            )}
        </SimpleForm>
      </Create>
    );
  }
}

const mapStateToProps = state => ({
  errors: state.form[`record-form`] ? state.form[`record-form`] : null
});

export default connect(mapStateToProps)(translate(StoreMessageCreateForm));



// WEBPACK FOOTER //
// ./src/containers/CRM/StoreMessages/StoreMessageCreateForm.js